import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {DeactivationAwareComponent} from '../common/can-deactivate/deactivation-aware.component';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<DeactivationAwareComponent> {

  canDeactivate(component: DeactivationAwareComponent): boolean {

    if (!component.canDeactivate()) {
      return confirm(component.deactivateWarning());
    }

    return true;
  }
}
